import { Button, Input, Keyboard, Layout, Row } from "../components";
import logo from "../assets/logo.svg";
import { useContext, useEffect, useState } from "react";
import { authService } from "../services";
import { User } from "../types";
import { useNavigate } from "react-router-dom";
import { Context } from "..";
import styled from "styled-components";
import { observer } from "mobx-react";

const Logo = styled.img`
  @media(max-width: 470px) {
    width: 128px;
  }
`;

const AuthPage = observer(() => {
  const [secretCode, setSecretCode] = useState<string>("");
  const [upperCase, setUpperCase] = useState<boolean>(false);
  const { store } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    if (store.isAuth) {
      return navigate(`/${store.user.type}`);
    }
  }, [navigate, store.isAuth, store.user.type]);

  const sendData = async () => {
    if (!secretCode) return alert("Укажите секретный код");

    const response: User | null = await authService.login(secretCode);

    if (!response) return alert("Неверный код");
    localStorage.setItem("token", response.token);
    window.location.reload();
  };

  return (
    <Layout title="Авторизация">
      <Logo src={logo} alt="Chiorio logotype" />
      <Row style={{ marginTop: 60 }}>
        <Input placeholder="Секретный код" value={secretCode} onChange={({ target }) => setSecretCode(target.value.toLowerCase())} />
        <Button onClick={sendData}>Продолжить</Button>
      </Row>
      <Keyboard
        isUpperCase={upperCase}
        onClick={(e: string) => {
          if (e === "<-") return setSecretCode((prev) => prev.substring(0, prev.length - 1));
          if (e === "SH") return setUpperCase((prev) => !prev);
          setSecretCode((prev) => prev + e);
          setUpperCase(false);
        }}
      />
    </Layout>
  );
});

export default AuthPage;
